import { Injectable } from '@angular/core';
import { TaggingService } from './tagging.service';

@Injectable({
  providedIn: 'root'
})
export class BrokerTaggingService extends TaggingService {
  public sendDataLayer(): void {}
}
